import i18n from '@batical/i18n'
import { RCoeffGSimplifie_Type } from '@batical/types/src'
const CoeffG = require('../json/CoeffGSimplifie.json')

export function fetchGSimpleVitrageSorted(): Array<{
  value: string
  label: string
}> {
  return [
    { value: 'vitrage_0', label: i18n.t('vitrage_0') },
    { value: 'vitrage_1', label: i18n.t('vitrage_1') },
    { value: 'vitrage_2', label: i18n.t('vitrage_2') }
  ]
}

export function fetchGSimplePlancherSorted(): Array<{
  value: string
  label: string
}> {
  return [
    { value: 'plancher_0', label: i18n.t('plancher_0') },
    { value: 'plancher_1', label: i18n.t('plancher_1') },
    { value: 'plancher_2', label: i18n.t('plancher_2') }
  ]
}

export function fetchGSimpleConfigSorted(): Array<{
  value: string
  label: string
}> {
  return [
    { value: 'config_0', label: i18n.t('config_0') },
    { value: 'config_1', label: i18n.t('config_1') },
    { value: 'config_2', label: i18n.t('config_2') },
    { value: 'config_3', label: i18n.t('config_3') }
  ]
}

export function fetchGSimplePlafondSorted(): Array<{
  value: string
  label: string
}> {
  return [
    { value: 'plafond_0', label: i18n.t('plafond_0') },
    { value: 'plafond_1', label: i18n.t('plafond_1') },
    { value: 'plafond_2', label: i18n.t('plafond_2') }
  ]
}

export function fetchGSimpleUMurExtrieurSorted(): Array<{
  value: string
  label: string
}> {
  return [
    { value: 'murs_0', label: i18n.t('murs_0') },
    { value: 'murs_1', label: i18n.t('murs_1') },
    { value: 'murs_2', label: i18n.t('murs_2') },
    { value: 'murs_3', label: i18n.t('murs_3') }
  ]
}

export function fetchCoeffGSimpl(
  mur: string,
  vitrage: string,
  plafond: string,
  plancher: string,
  config: string
): RCoeffGSimplifie_Type | null {
  let gsimpl = CoeffG.filter(
    (item: RCoeffGSimplifie_Type) =>
      item.murs === mur && item.vitrage === vitrage && item.plafond === plafond && item.plancher === plancher && item.config === config
  )
  if (gsimpl && gsimpl.length > 0) {
    return gsimpl[0]
  }
  return null
}
